import Typography from "@mui/material/Typography";
import {Button, Stack, TextField} from "@mui/material";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import DinoDialog from "../../../components/Dialog";
import {useState, useContext} from "react";
import {AuthContext} from "../../../context/AuthContext";
import useColleagueQueries from "../../../hooks/queries/useColleagueQueries";

const DeleteAccount = () => {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const {deleteUserMutation} = useColleagueQueries()
    const {logout, getUser} = useContext(AuthContext)
    const user = getUser()

    const [confirmationText, setConfirmationText] = useState('')

    const deleteAccount = () => {
        deleteUserMutation.mutate(user?.user_id, {onSuccess: () => logout(), onError: () => alert('Sikertelen törlés!')})
    }

    const foreverDeleteActions = <>
        <Button variant='outlined' style={{padding: 15}} onClick={() => setDeleteDialogOpen(false)}>Mégsem</Button>
        <Button variant='contained' style={{padding: 15}} disabled={confirmationText.toUpperCase() !== 'TÖRLÉS'} onClick={() => {
            setDeleteDialogOpen(false)
            deleteAccount()
        }} endIcon={<DeleteForeverRoundedIcon/>}>Fiók törlése</Button>
    </>

    return <div className="white-card">
        <Typography variant='subtitle2'>Fiók törlése</Typography>
        <Typography variant='body2' color='#536B74' gutterBottom>
            Ha "tulajdonos" felhasználóként kitörlöd a
            fiókot minden adat elvész.
        </Typography>
        <Button
            onClick={() => setDeleteDialogOpen(true)}
            endIcon={<DeleteForeverRoundedIcon/>}>
            Fiók törlése
        </Button>

        <DinoDialog
            open={deleteDialogOpen}
            handleClose={() => setDeleteDialogOpen(false)}
            title='Fiók törlése'
            subtitle='Ha admin felhasználóként törli a fiókot minden adat elvész!'
            actions={foreverDeleteActions}>
            <Stack spacing={1}>
                <Typography variant='caption'>Ha biztosan törölni szeretné gépelje be a "törlés" szót</Typography>
                <TextField variant='standard' value={confirmationText} onChange={e => setConfirmationText(e.target.value)}/>
            </Stack>
        </DinoDialog>
    </div>
}

export default DeleteAccount